import type { GeneralParameters } from '../../general/parameters/general'
import type { ContentActionUiActionParameters } from '../models/content-actions'
import type { UiActionParameters } from '../parameters/ui-action'

import { parameters } from '../parameters/content-actions-ui-action'
import { UiActionEvent } from './ui-action'

export class ContentActionsUiActionEvent extends UiActionEvent {
  parameters = parameters

  constructor(contentActionParams: ContentActionUiActionParameters) {
    super(contentActionParams)
  }

  override validate(): false | [GeneralParameters, UiActionParameters] {
    const general = Object.fromEntries(this.general)

    if (
      !general.contentUserSubscriberId ||
      !general.contentUserAccountNumber ||
      !general.contentUserProfileId
    ) {
      return false
    }

    const validated = super.validate()
    if (!validated) return false

    const [generalParams, uiActionParams] = validated
    const { routeName, ...params } =
      uiActionParams as ContentActionUiActionParameters

    const route = routeName
      ? [params.route, routeName].filter(Boolean).join('/')
      : params.route

    return [generalParams, { ...params, ...(route ? { route } : {}) }]
  }
}
